import { Button, Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Dialog } from 'vet-bones/components';

import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';

interface WithAlertOptions {
  className?: string;
  okPrompt?: string;
  onClose?: () => any;
  message: React.ReactNode;
}

interface WithAlertProps extends WithAlertOptions {
  okPrompt: string;
  onClose: () => any;
}

export const WithAlert: React.VFC<WithAlertProps> = ({
  className,
  okPrompt,
  message,
  onClose,
}) => {
  return (
    <Dialog
      autoFocus={false}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      className={classNames('sd-dialog-alert', className)}
      enforceFocus={false}
      isCloseButtonShown={false}
      isOpen
    >
      <div className={Classes.DIALOG_BODY}>
        <div>{message}</div>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            className={Classes.POPOVER_OPEN}
            data-testid={TEST_IDS.dialog.alert.okButton}
            onClick={onClose}
            text={okPrompt}
          />
        </div>
      </div>
    </Dialog>
  );
};

// Render an unattached dialog for receiving confirmation imperatively.
export const withAlert = ({
  className,
  message,
  okPrompt = copy.components.defaults.alert.ok,
  onClose,
}: WithAlertOptions) => {
  const node = document.createElement('div');
  ReactDOM.render(
    <WithAlert
      className={className}
      message={message}
      okPrompt={okPrompt}
      onClose={() => {
        ReactDOM.unmountComponentAtNode(node);
        node.remove();
        if (onClose) {
          onClose();
        }
      }}
    />,
    node
  );
};
